import loadTableViewFromTableQuery from './loadTableViewFromTableQuery';
import { getDefaultInboxTableQuery } from 'owa-mail-triage-table-utils/lib/getDefaultInboxTableQueries';

// Function that loads the default table view.
export function loadDefaultTable() {
    // Load default inbox table
    loadTableViewFromTableQuery(getDefaultInboxTableQuery());
}
